import React, { useRef, useState } from "react";
import { View, StyleSheet, ScrollView, Image, TouchableWithoutFeedback, Modal, Platform } from "react-native";

import AppText from "./AppText";
import config from "../config/config";
import useMedia from "../hooks/useMedia";
import IconTouchable from "./IconTouchable";
import { makeID } from "../utility/makeID";
import ImageViewer from "./ImageViewer";
import { Video, AVPlaybackStatus } from "expo-av";
import * as mime from "mime";

function ImageCarousel({
    imageData = false,
    enableUpload = true,
    itemID,
    onComplete,
    uploadApi,
    deleteApi,
    buttonText = "Add Image",
}) {
    const scrollView = useRef();
    const { selectImageFromLibrary, selectImageFromCamera } = useMedia();

    const [imageViewer, setImageViewer] = useState(false);
    const video = React.useRef(null);
    const [status, setStatus] = React.useState({});

    const upLoadImageFromLibrary = async () => {
        let image = await selectImageFromLibrary();
        if (image) {
            await uploadData(image);
        }
    };

    const uploadData = async (image) => {
        let formdata = new FormData();
        var extension = image.slice(-4);

        // IF YOU DONT HAVE THE CURRENT MIME TYPE HERE IT WONT WORK ON ANDROID
        //AND IT WONT TELL YOU WHY, CHANGE AT YOUR OWN PERIL.
        const mimeType = mime.getType(image);

        formdata.append("file", {
            uri: image,
            type: mimeType,
            name: makeID(20) + extension,
        });

        formdata.append("productID", itemID);

        var response;
        if (Platform.OS === "web") {
            response = await uploadApi.request(itemID, image);
        } else {
            response = await uploadApi.request(formdata);
        }

        if (response.ok) {
            onComplete();
        }
    };

    return (
        <View style={{ backgroundColor: config.colors.tertiary, justifyContent: "center", alignItems: "flex-start" }}>
            <ScrollView
                ref={scrollView}
                horizontal
                showsHorizontalScrollIndicator={false}
                onContentSizeChange={() => scrollView.current.scrollToEnd()}
            >
                {imageData.length > 0 ? (
                    <View style={styles.imageContainer}>
                        {imageData.map((image) =>
                            image.slice(-4) == ".mov" ? (
                                <TouchableWithoutFeedback
                                    key={image}
                                    onPress={() => {
                                        setImageViewer(true);
                                    }}
                                >
                                    <Video
                                        ref={video}
                                        style={{ width: 125, height: 125 }}
                                        source={{
                                            uri: image,
                                        }}
                                        resizeMode="cover"
                                        volume={0}
                                        isLooping={false}
                                        onPlaybackStatusUpdate={(status) => setStatus(() => status)}
                                    />
                                </TouchableWithoutFeedback>
                            ) : (
                                <TouchableWithoutFeedback
                                    key={image}
                                    onPress={() => {
                                        setImageViewer(true);
                                    }}
                                >
                                    <Image
                                        style={{ width: 125, height: 125, borderColor: config.colors.primary }}
                                        source={{ uri: image }}
                                        resizeMode="cover"
                                    />
                                </TouchableWithoutFeedback>
                            )
                        )}
                    </View>
                ) : (
                    <View
                        style={{
                            width: 125,
                            height: 125,
                            borderColor: config.colors.primary,
                            justifyContent: "center",
                            alignItems: "center",
                            marginLeft: 20,
                        }}
                    >
                        <AppText style={styles.text}>No Photos Available</AppText>
                    </View>
                )}
                {enableUpload && (
                    <View style={{ alignItems: "center", justifyContent: "center", padding: 15 }}>
                        <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                            <IconTouchable name="folder-multiple-image" onPress={() => upLoadImageFromLibrary()} />
                        </View>
                        <AppText style={styles.text} numberOfLines={1}>
                            {buttonText}
                        </AppText>
                    </View>
                )}
            </ScrollView>
            <ImageViewer
                imageData={imageData}
                vehicle={itemID}
                imageViewer={imageViewer}
                setImageViewer={setImageViewer}
                deleteApi={deleteApi}
            ></ImageViewer>
        </View>
    );
}
const styles = StyleSheet.create({
    imageContainer: {
        flexDirection: "row",
    },
    text: {
        alignSelf: "center",
        fontSize: 16,
        fontWeight: "900",
        color: config.colors.white,
    },
    image: { flex: 1 },
});

export default ImageCarousel;
